import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CadensSharedModule } from '../../shared';
import { CadensAdminModule } from '../../admin/admin.module';

import {
    faqRoute
} from './';
import {FaqComponent} from './faq.component';

let ENTITY_STATES = [
    ...faqRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        FaqComponent
    ],
    entryComponents: [
        FaqComponent
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensFaqModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/faq/faq.module.ts